import { Row } from 'antd';
import dayjs from 'dayjs';
import React from 'react';

import ButtonComponent from 'components/atoms/ButtonComponent';

import { IKorporatniAkce } from 'services/korporatniAkce/korporatniAkce';

import { ETypUdalosti } from 'enums/akcionarKorpAkce/typUdalosti';
import { EkorpAkceButtonType } from 'enums/korporatniAkceTypes';

interface DetailButtons {
    data: IKorporatniAkce;
    openModal: (val: EkorpAkceButtonType) => void;
}
const {
    SRD_DETAIL_TL_JINA,
    SRD_DETAIL_TL_POT,
    SRD_DETAIL_TL_STR,
    SRD_DETAIL_TL_VH,
    SRD_DETAIL_TL_VHODP,
    SRD_DETAIL_TL_VHZRUS,
    SRD_DETAIL_TL_VYPIS,
    SRD_DETAIL_TL_VYPISODP,
    SRD_DETAIL_TL_VYPISZRUS,
    SRD_DETAIL_TL_VYSL,
    SRD_DETAIL_TL_ZAP
} = EkorpAkceButtonType;
export const VHButtons: React.FC<DetailButtons> = ({ data, openModal }) => {
    const PozadavekPredZverejnenim = data.sezakci.filter(e => dayjs(e.datumzverejneni) > dayjs());
    return (
        <Row className="button-row">
            {dayjs().isBefore(data.datumkonani) && !PozadavekPredZverejnenim.length && (
                <ButtonComponent
                    id="VHZRUSbtn"
                    buttontext="SRD_DETAIL_TL_VHZRUS"
                    onClick={() => openModal(SRD_DETAIL_TL_VHZRUS)}
                />
            )}
            {dayjs().isBefore(data.datumkonani) && !PozadavekPredZverejnenim.length && (
                <ButtonComponent id="VHbtn" buttontext="SRD_DETAIL_TL_VH" onClick={() => openModal(SRD_DETAIL_TL_VH)} />
            )}
            {dayjs().isBefore(data.datumkonani) && (
                <ButtonComponent
                    id="VYPISbtn"
                    buttontext="SRD_DETAIL_TL_VYPIS"
                    onClick={() => openModal(SRD_DETAIL_TL_VYPIS)}
                />
            )}
            {/* dayjs().isBefore(data.rozhodnyden) && (
                <ButtonComponent
                    id="VYPISZRUSbtnalt"
                    buttontext="SRD_DETAIL_TL_VYPISZRUS"
                    onClick={() => openModal(SRD_DETAIL_TL_VYPISZRUS)}
                   
                />
            )*/}
            {/* data.sezakci.find(({ typudalosti }) => typudalosti === ETypUdalosti.VYPISODP) && (
                <ButtonComponent
                    id="VYPISODPbtnalt"
                    buttontext="SRD_DETAIL_TL_VYPISODP"
                    onClick={() => openModal(SRD_DETAIL_TL_VYPISODP)}
                   
                />
            )*/}
            {data.sezakci.find(({ typudalosti }) => typudalosti === ETypUdalosti.VHODP) && (
                <>
                    <ButtonComponent
                        id="VHODPbtn"
                        buttontext="SRD_DETAIL_TL_VHODP"
                        onClick={() => openModal(SRD_DETAIL_TL_VHODP)}
                        style={{
                            marginLeft: 10
                        }}
                    />
                    <ButtonComponent
                        id="POTbtn"
                        buttontext="SRD_DETAIL_TL_POT"
                        onClick={() => openModal(SRD_DETAIL_TL_POT)}
                        style={{
                            marginLeft: 10
                        }}
                    />
                    <ButtonComponent
                        id="STRbtn"
                        buttontext="SRD_DETAIL_TL_STR"
                        onClick={() => openModal(SRD_DETAIL_TL_STR)}
                        style={{
                            marginLeft: 10
                        }}
                    />
                    <ButtonComponent
                        id="ZAPbtn"
                        buttontext="SRD_DETAIL_TL_ZAP"
                        onClick={() => openModal(SRD_DETAIL_TL_ZAP)}
                        style={{
                            marginLeft: 10
                        }}
                    />
                </>
            )}
            {dayjs().isAfter(data.datumkonani) && (
                <ButtonComponent
                    id="VYSLbtn"
                    buttontext="SRD_DETAIL_TL_VYSL"
                    onClick={() => openModal(SRD_DETAIL_TL_VYSL)}
                />
            )}
        </Row>
    );
};

export const VYPISButtons: React.FC<DetailButtons> = ({ data, openModal }) => {
    return (
        <Row className="button-row">
            <ButtonComponent
                id="VYPISZRUSbtn"
                buttontext="SRD_DETAIL_TL_VYPISZRUS"
                onClick={() => openModal(SRD_DETAIL_TL_VYPISZRUS)}
            />
            {data.sezakci.find(({ typudalosti }) => typudalosti === ETypUdalosti.VYPISODP) && (
                <ButtonComponent
                    id="VYPISODPbtn"
                    buttontext="SRD_DETAIL_TL_VYPISODP"
                    onClick={() => openModal(SRD_DETAIL_TL_VYPISODP)}
                />
            )}
        </Row>
    );
};

export const JINAButtons: React.FC<DetailButtons> = ({ data, openModal }) => {
    return (
        <Row className="button-row">
            {dayjs().isBefore(data.datumkonani) && (
                <ButtonComponent
                    id="JINAbtn"
                    buttontext="SRD_DETAIL_TL_JINA"
                    onClick={() => openModal(SRD_DETAIL_TL_JINA)}
                />
            )}
        </Row>
    );
};
